const MAP_STYLE = [
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ebebeb',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#d6d6d6',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#919db1',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#afb4c0',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        weight: 3,
      },
    ],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e2e4e9',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#cfd4d5',
      },
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e2e4e9',
      },
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#919db1',
      },
    ],
  },
  {
    featureType: 'landscape.natural.terrain',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.attraction',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.government',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.medical',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.place_of_worship',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.school',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        saturation: -45,
      },
      {
        lightness: 10,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#41626b',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#afb4c0',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        weight: 2,
      },
    ],
  },
  {
    featureType: 'road.highway',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#adb9bd',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#afb4c0',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#909598',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.icon',
    stylers: [
      {
        saturation: 45,
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#e2e4e9',
      },
      {
        saturation: -100,
      },
      {
        lightness: -5,
      },
    ],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.icon',
    stylers: [
      {
        color: '#adadad',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#a8dcff',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#adadad',
      },
    ],
  },
];

const getRiderSVG = ({ rotationAngle, width, height }) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" transform="rotate(${rotationAngle})" viewBox="0 0 150 150">
			<g>
				<clipPath id="clip-path">
					<rect width="${width}" height="${height}" />
				</clipPath>
				<path d="M80.612,123.437H70.094V137.742C70.094,140.687 72.408,143.001 75.353,143.001C78.298,143.001 80.612,140.687 80.612,137.742V123.437Z" fill="#000000" />
				<path
					d="M75.346,37.976C81.656,37.976 87.547,34.4 92.595,35.451C94.068,35.872 95.33,34.189 94.489,32.927C91.123,26.827 83.76,23.25 75.135,23.25C66.51,23.25 59.148,26.827 55.782,32.927C54.94,34.189 56.202,35.872 57.675,35.451C63.145,34.4 69.035,37.976 75.346,37.976Z"
					fill="#363636"
				/>
				<path d="M80.612,25.353H70.094V11.259C70.094,8.314 72.408,6 75.353,6C78.298,6 80.612,8.314 80.612,11.259V25.353Z" fill="#000000" />
				<path d="M80.612,123.437H70.094V137.742C70.094,140.687 72.408,143.001 75.353,143.001C78.298,143.001 80.612,140.687 80.612,137.742V123.437Z" fill="#000000" />
				<path
					d="M75.348,137.113C80.111,137.113 83.972,133.534 83.972,129.119C83.972,124.704 80.111,121.125 75.348,121.125C70.584,121.125 66.723,124.704 66.723,129.119C66.723,133.534 70.584,137.113 75.348,137.113Z"
					fill="#FFE141"
				/>
				<path
					d="M109.853,35.872C109.642,35.872 109.642,35.872 109.432,35.872C100.807,31.455 88.185,28.72 75.353,28.72C62.311,28.72 49.899,31.244 41.274,35.872C40.854,36.083 40.223,35.872 40.012,35.451C39.802,34.82 40.012,34.4 40.433,33.979C49.479,29.351 62.1,26.616 75.353,26.616C88.606,26.616 101.228,29.351 110.273,33.979C110.694,34.189 110.905,34.82 110.694,35.451C110.484,35.662 110.063,35.872 109.853,35.872Z"
					fill="#000000"
				/>
				<path
					d="M40.848,36.5C40.217,36.5 39.375,36.079 39.165,35.448C38.744,34.606 39.165,33.344 40.007,32.923C43.583,31.24 47.79,29.978 52.418,28.716C53.47,28.506 54.521,29.137 54.732,30.189C54.942,31.24 54.311,32.292 53.259,32.503C48.842,33.554 45.055,34.817 41.689,36.289C41.479,36.5 41.058,36.5 40.848,36.5Z"
					fill="#000000"
				/>
				<path
					d="M109.842,36.504C109.631,36.504 109.211,36.504 109,36.293C105.634,34.821 101.637,33.348 97.22,32.297C96.168,32.086 95.537,31.034 95.747,29.983C95.958,28.931 97.009,28.3 98.061,28.51C102.689,29.562 106.897,31.034 110.473,32.717C111.314,33.138 111.735,34.19 111.314,35.242C111.104,36.083 110.473,36.504 109.842,36.504Z"
					fill="#000000"
				/>
				<path
					d="M88.815,98.562H61.889C61.889,98.562 59.365,73.739 59.575,65.325C59.785,57.12 63.782,32.718 63.782,32.718L86.922,32.718C86.922,32.718 90.919,57.12 91.129,65.325C91.34,73.739 88.815,98.562 88.815,98.562Z"
					fill="#1C1C1C"
				/>
				<path
					d="M42.742,30.19C42.742,30.19 42.742,33.977 43.373,36.081C44.004,38.184 43.373,39.236 43.373,39.236L48.632,40.288L49.053,36.081C49.053,36.081 52.84,34.398 52.84,33.556C52.84,32.715 50.736,32.504 50.736,31.873C50.736,31.242 50.736,28.718 50.736,28.718L42.742,30.19Z"
					fill="#FFC093"
				/>
				<path
					d="M71.565,61.747C59.574,61.747 48.425,54.174 48.425,40.29C48.425,40.079 48.425,39.869 48.425,39.448C48.425,39.448 44.218,39.238 42.114,39.238C41.693,58.591 56.839,72.475 69.04,72.475C76.614,72.475 81.873,67.847 84.818,60.905C81.031,61.747 76.614,61.747 71.565,61.747Z"
					fill="#FFE141"
				/>
				<path
					d="M48.424,40.08C48.424,39.869 48.424,39.659 48.424,39.238C48.424,39.238 44.217,39.028 42.113,39.028C42.113,39.659 42.113,40.29 42.113,40.921L48.424,41.973C48.634,41.342 48.424,40.711 48.424,40.08Z"
					fill="#8D7800"
				/>
				<path
					d="M107.957,30.191C107.957,30.191 107.957,33.978 107.536,36.081C107.115,38.185 107.536,39.237 107.536,39.237L102.067,40.078L101.646,35.871C101.646,35.871 97.859,34.188 97.859,33.347C97.859,32.505 99.963,32.295 99.963,31.664C99.963,31.033 99.963,28.508 99.963,28.508L107.957,30.191Z"
					fill="#FFC093"
				/>
				<path
					d="M78.929,61.747C90.919,61.747 102.069,54.174 102.069,40.29C102.069,40.079 102.069,39.869 102.069,39.448C102.069,39.448 106.276,39.238 108.379,39.238C108.8,58.591 93.654,72.475 81.453,72.475C73.88,72.475 68.621,67.847 65.676,60.905C69.462,61.747 74.09,61.747 78.929,61.747Z"
					fill="#FFE141"
				/>
				<path
					d="M102.062,40.08C102.062,39.869 102.062,39.659 102.062,39.238C102.062,39.238 106.27,39.028 108.373,39.028C108.373,39.659 108.373,40.29 108.373,40.921L102.062,41.973C102.062,41.342 102.062,40.711 102.062,40.08Z"
					fill="#8D7800"
				/>
				<path
					d="M56.606,78.525C55.133,72.074 53.449,64.19 55.343,62.518C64.183,67.774 85.229,68.968 94.7,62.518C96.594,64.19 94.91,72.552 93.227,79.003C93.016,80.198 92.174,81.631 91.122,83.064C88.386,87.126 83.966,89.515 79.336,89.515H70.497C65.025,89.515 59.974,86.409 57.448,80.914C57.027,79.959 56.606,79.242 56.606,78.525Z"
					fill="#FFE141"
				/>
				<path
					d="M61.715,59.815C67.835,63.934 82.408,64.87 88.966,59.815C94.424,65.269 87.981,84.032 78.132,83.929H72.012C60.349,83.064 56.233,65.292 61.715,59.815Z"
					stroke="0.3"
					fill="#DDBC09"
					fill-opacity="0.3"
				/>
				<path
					d="M87.369,133.893C79.252,133.893 70.937,133.893 62.82,133.893C59.257,133.893 55.693,130.706 55.297,126.669C54.109,116.682 54.109,106.695 55.297,96.92C55.891,92.883 59.257,89.695 62.82,89.695C70.937,89.695 79.252,89.695 87.369,89.695C90.933,89.695 94.496,92.883 94.892,96.92C96.08,106.907 96.08,116.894 94.892,126.669C94.496,130.918 90.933,133.893 87.369,133.893Z"
					fill="#0C831F"
				/>
				<path
					d="M63.716,109.628C64.211,109.628 64.652,109.75 65.041,109.995C65.433,110.235 65.74,110.578 65.963,111.021C66.178,111.447 66.286,111.948 66.286,112.523C66.286,113.082 66.178,113.581 65.963,114.021C65.747,114.461 65.443,114.805 65.051,115.052C64.656,115.304 64.211,115.429 63.716,115.429C63.356,115.429 63.017,115.356 62.699,115.209C62.381,115.063 62.109,114.857 61.883,114.592V115.298H60.039V107.801H61.883V110.461C62.109,110.195 62.381,109.991 62.699,109.848C63.017,109.701 63.356,109.628 63.716,109.628ZM63.165,113.916C63.426,113.916 63.66,113.857 63.864,113.738C64.069,113.62 64.23,113.454 64.346,113.241C64.463,113.031 64.521,112.792 64.521,112.523C64.521,112.262 64.463,112.024 64.346,111.811C64.23,111.598 64.069,111.433 63.864,111.314C63.66,111.195 63.426,111.136 63.165,111.136C62.918,111.136 62.697,111.195 62.503,111.314C62.308,111.429 62.157,111.592 62.047,111.801C61.938,112.014 61.883,112.255 61.883,112.523C61.883,112.792 61.938,113.033 62.047,113.246C62.157,113.455 62.308,113.62 62.503,113.738C62.697,113.857 62.918,113.916 63.165,113.916Z"
					fill="#F8CB46"
				/>
				<path d="M66.538,115.298V107.801H68.382V115.298H66.538Z" fill="#F8CB46" />
				<path d="M68.905,115.298V109.754H70.738V115.298H68.905Z" fill="#F8CB46" />
				<path
					d="M74.72,109.628C75.112,109.628 75.465,109.719 75.78,109.9C76.094,110.078 76.341,110.33 76.521,110.654C76.695,110.982 76.781,111.354 76.781,111.77V115.298H75.022V112.178C75.022,111.975 74.981,111.796 74.9,111.639C74.822,111.478 74.711,111.354 74.566,111.267C74.425,111.18 74.259,111.136 74.068,111.136C73.888,111.136 73.722,111.18 73.57,111.267C73.418,111.351 73.3,111.466 73.215,111.612C73.127,111.752 73.083,111.916 73.083,112.105L73.072,115.298H71.239V109.754H73.072V110.387C73.245,110.15 73.477,109.965 73.766,109.832C74.056,109.696 74.374,109.628 74.72,109.628Z"
					fill="#F8CB46"
				/>
				<path
					d="M80.832,112.178L82.914,115.298H80.832L79.614,113.335L79.052,113.979V115.298H77.208V107.801H79.052V111.942L80.822,109.754H82.904L80.832,112.178Z"
					fill="#F8CB46"
				/>
				<path d="M68.904,107.801H70.743V109.223H68.904V107.801Z" fill="#F8CB46" />
				<path d="M83.206,115.286V109.741H85.039L85.039,115.286H83.206Z" fill="#ffffff" />
				<path
					d="M88.915,113.721L89.281,114.888C89.115,115.045 88.905,115.173 88.65,115.27C88.4,115.368 88.154,115.417 87.914,115.417C87.568,115.417 87.259,115.342 86.987,115.192C86.715,115.038 86.503,114.825 86.351,114.553C86.199,114.288 86.123,113.982 86.123,113.637V111.192H85.387V109.741H86.123V107.806H87.882V109.741H89.043V111.192H87.882V113.302C87.882,113.48 87.93,113.625 88.025,113.736C88.121,113.848 88.242,113.904 88.391,113.904C88.497,113.904 88.596,113.888 88.688,113.857C88.779,113.825 88.855,113.78 88.915,113.721Z"
					fill="#ffffff"
				/>
				<path d="M83.191,107.806H85.031V109.227H83.191V107.806Z" fill="#ffffff" />
				<path
					d="M75.346,37.976C81.656,37.976 87.547,34.4 92.595,35.451C94.068,35.872 95.33,34.189 94.489,32.927C91.123,26.827 83.76,23.25 75.135,23.25C66.51,23.25 59.148,26.827 55.782,32.927C54.94,34.189 56.202,35.872 57.675,35.451C63.145,34.4 69.035,37.976 75.346,37.976Z"
					fill="#363636"
				/>
				<path d="M80.612,25.353H70.094V11.259C70.094,8.314 72.408,6 75.353,6C78.298,6 80.612,8.314 80.612,11.259V25.353Z" fill="#000000" />
				<path d="M82.586,29.12H68.48V19.605C68.48,16.508 71.066,14.074 74.358,14.074H76.709C80,14.074 82.586,16.508 82.586,19.605V29.12Z" fill="#696969" />
				<path
					d="M83.972,23.879C83.972,28.296 80.186,31.872 75.348,31.872C70.509,31.872 66.723,28.296 66.723,23.879C66.723,19.461 70.509,18.62 75.348,18.62C80.186,18.62 83.972,19.461 83.972,23.879Z"
					fill="#696969"
				/>
				<path
					d="M75.346,19.672C70.929,19.672 67.773,20.303 67.773,23.88C67.773,24.511 72.612,24.931 75.346,24.931C78.081,24.931 82.92,24.511 82.92,23.88C82.92,20.303 79.764,19.672 75.346,19.672Z"
					fill="#FFE141"
				/>
				<path
					d="M87.974,54.802C87.974,62.375 82.294,68.686 75.352,68.686C68.41,68.686 62.73,62.586 62.73,54.802C62.73,47.019 68.41,42.812 75.352,42.812C82.294,42.812 87.974,47.229 87.974,54.802Z"
					fill="#FFEA7A"
				/>
				<path
					d="M75.344,77.731C83.244,77.731 89.648,71.233 89.648,63.216C89.648,55.2 83.244,48.701 75.344,48.701C67.443,48.701 61.039,55.2 61.039,63.216C61.039,71.233 67.443,77.731 75.344,77.731Z"
					fill="#DDBC09"
				/>
			</g>
		</svg>`;
};
export { MAP_STYLE, getRiderSVG };
